import { createAction } from 'redux-actions';
export const fetchGruserSuccess = createAction('@@gruser.GRUSER.FETCH.SUCCESS', (gruser)=>({
        gruser
    }));

//# sourceMappingURL=gruser.js.map